var $fcd2d84b9a2d489c$exports = {};
$fcd2d84b9a2d489c$exports = {
    "dropzoneLabel": `B\u{131}rakma B\xf6lgesi`,
    "selectPlaceholder": `Bir \xf6\u{11F}e se\xe7in`,
    "tableResizer": `Yeniden boyutland\u{131}r\u{131}c\u{131}`,
    "colorSwatchPicker": `Color swatches`
};


export {$fcd2d84b9a2d489c$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
